import { readPsd, Psd } from 'ag-psd';

// Shared PSD parsing logic to reduce duplication
export async function parsePSDWithErrorHandling(
  fileBuffer: ArrayBuffer
): Promise<Psd> {
  try {
    return readPsd(fileBuffer);
  } catch (parseError: unknown) {
    const errorMessage =
      parseError instanceof Error
        ? parseError.message
        : String(parseError);
    
    if (
      errorMessage.includes('CMYK') ||
      errorMessage.includes('Color mode not supported')
    ) {
      try {
        console.warn(
          'CMYK color mode detected, attempting to parse with relaxed options...'
        );
        const psd = readPsd(fileBuffer, {
          throwForMissingFeatures: false,
          logMissingFeatures: true,
          skipLayerImageData: false,
          skipCompositeImageData: false,
        });
        console.warn('Successfully parsed CMYK PSD with relaxed options');
        return psd;
      } catch (retryError: unknown) {
        const retryErrorMessage =
          retryError instanceof Error ? retryError.message : 'Unknown error';
        throw new Error(
          `CMYK color mode is not fully supported. Some features may be missing. Please convert your PSD file to RGB color mode in Photoshop for best results. Original error: ${retryErrorMessage}`
        );
      }
    }
    throw parseError;
  }
}

export function validatePSD(psd: Psd | null): void {
  if (!psd) {
    throw new Error('Failed to parse PSD file');
  }
}
